import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Table from "react-bootstrap/Table";
import Sidebar from "../../components/Sidebar";
import { RiEyeLine } from "react-icons/ri";
import Loader from "../../components/Loader";
import { ProfileContext } from "../../context/ProfileContext";
import { diagnosticCategories } from "../../utils/helper";
import { Col, Form, Row } from "react-bootstrap";

function DiagnosticsTestManagement() {
  const navigate = useNavigate();
  const { diagnosticsTest, diagnosticsTestPagination, getTests, isLoading } = useContext(ProfileContext)
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("");
  
  const getPaginationText = () => {
    if (!diagnosticsTestPagination || diagnosticsTestPagination.totalCount === 0) { return }
    const start = (diagnosticsTestPagination.currentPage - 1) * diagnosticsTestPagination.limit + 1;
    const end = Math.min(diagnosticsTestPagination.currentPage * diagnosticsTestPagination.limit, diagnosticsTestPagination.totalCount);
    return `${start}-${end} of ${diagnosticsTestPagination.totalCount} items`;
  };

  const handleNext = () => {
    if (diagnosticsTestPagination && diagnosticsTestPagination.currentPage < diagnosticsTestPagination.totalPages) {
      getTests(diagnosticsTestPagination.currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (diagnosticsTestPagination && diagnosticsTestPagination.currentPage > 1) {
      getTests(diagnosticsTestPagination.currentPage - 1);
    }
  };

  const handleSearch = () => {getTests(1, searchText, category)}

  const handleClear = () => {
    setSearchText("");
    setCategory("");
    getTests(1, "", "");
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex">
                <div>
                  <h6 className="comm_page_heading">Diagnostics Test Management</h6>
                  <p className="comm_page_sub_heading">
                    Receive AI-driven diagnostic suggestions based on consultation
                    data, helping guide accurate and timely treatment decisions
                  </p>
                </div>
              </div>

              <Row>
                <Col md={3}>
                  <Form.Group className="comn-class-inputs">
                    <Form.Label>Search Diagnostic Test</Form.Label>
                    <Form.Control type="text" placeholder="Enter test name" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="comn-class-inputs">
                    <Form.Label>Select Category</Form.Label>
                    <Form.Select value={category} onChange={(e) => { setCategory(e.target.value) }}>
                      <option value="">Select Category</option>
                      {diagnosticCategories.map((cat) => (<option key={cat.value} value={cat.value}>{cat.label}</option>))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6} className="d-flex align-items-center justify-content-end">
                  {(searchText || category) && (
                    <>
                      <button className="main-btn me-3" onClick={handleSearch}>Search</button>
                      <button className="main-btn main-btn-light me-3" onClick={handleClear}>Clear</button>
                    </>
                  )}
                  <button className='main-btn' onClick={() => navigate('/add-diagnostic-test')}>Add Diagnostic Test</button>
                </Col>
              </Row>

              <div className="comm-table pt-0 refferal_table_outer">
                <Table>
                  <thead>
                    <tr className="head-class-td">
                      <th>Sr. no.</th>
                      <th>Test Name</th>
                      <th>Category</th>
                      <th width="10%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {diagnosticsTest && diagnosticsTest.length > 0 ?
                      diagnosticsTest.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{(diagnosticsTestPagination?.currentPage - 1) * diagnosticsTestPagination.limit + index + 1}</td>
                            <td>{item?.test_name}</td>
                            <td>{item?.category}</td>
                            <td><Link className="table-view-btn" to="/view-diagnostic-test" state={item}><RiEyeLine /></Link></td>
                          </tr>
                        )
                      })
                      :
                      <tr><td colSpan={6}>No Tests added yet!</td></tr>
                    }
                  </tbody>

                </Table>
              </div>

              <div className="d-flex table_bottom_row">
                <h4 className="page_count_txt">{getPaginationText()}</h4>
                <div className="d-flex btn_grp">
                  <button className="table_bott_btn" onClick={handlePrevious} disabled={!diagnosticsTestPagination || diagnosticsTestPagination.currentPage <= 1}>Previous</button>
                  <button className="table_bott_btn" onClick={handleNext} disabled={!diagnosticsTestPagination || diagnosticsTestPagination.currentPage >= diagnosticsTestPagination.totalPages}>Next</button>
                </div>
              </div>
            </section>
          </div>
        </div >
      </div >
    </>
  );
}

export default DiagnosticsTestManagement;
